module.exports = __webpack_public_path__ + "static/media/system_b.1769f5ff.png";